'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var theme = require('../../consts/theme.js');
var Backdrop_module = require('./Backdrop.module.css.js');
var ViewportConfigProvider = require('../../providers/ViewportConfigProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Backdrop = _ref => {
  var _viewportConfig$ancho, _viewportConfig$ancho2, _viewportConfig$ancho3, _viewportConfig$ancho4;
  let {
    s,
    children
  } = _ref;
  const viewportConfig = ViewportConfigProvider.useViewportConfig();
  return /*#__PURE__*/React__default["default"].createElement("div", _extends__default["default"]({
    className: Backdrop_module["default"].backdropContainer
  }, viewportConfig.anchor, {
    style: {
      zIndex: theme.zIndex.Modal,
      top: ((_viewportConfig$ancho = viewportConfig.anchor) === null || _viewportConfig$ancho === void 0 ? void 0 : _viewportConfig$ancho.offsetTop) ?? 0,
      bottom: ((_viewportConfig$ancho2 = viewportConfig.anchor) === null || _viewportConfig$ancho2 === void 0 ? void 0 : _viewportConfig$ancho2.offsetBottom) ?? 0,
      left: ((_viewportConfig$ancho3 = viewportConfig.anchor) === null || _viewportConfig$ancho3 === void 0 ? void 0 : _viewportConfig$ancho3.offsetLeft) ?? 0,
      right: ((_viewportConfig$ancho4 = viewportConfig.anchor) === null || _viewportConfig$ancho4 === void 0 ? void 0 : _viewportConfig$ancho4.offsetRight) ?? 0,
      ...s
    }
  }), children);
};

exports["default"] = Backdrop;
